module.exports = __webpack_public_path__ + "static/computer-and-teapot-0c0a2e2a97cef3da8701baa139871665.png";